/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Error_Modal_TitleInputs */

const en_validation_error_modal_title = /** @type {(inputs: Validation_Error_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validation Errors Detected`)
};

const nl_validation_error_modal_title = /** @type {(inputs: Validation_Error_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Validatiefouten Gedetecteerd`)
};

/**
* | output |
* | --- |
* | "Validation Errors Detected" |
*
* @param {Validation_Error_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const validation_error_modal_title = /** @type {((inputs?: Validation_Error_Modal_TitleInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Error_Modal_TitleInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_validation_error_modal_title(inputs)
	return en_validation_error_modal_title(inputs)
});